import * as React from 'react';
import {BlockType} from 'api/task/types';
import {useBlockContext} from '../../hooks/useBlockContext';
import * as components from './components';

/**
 * The content of the block.
 * @return {React.ReactElement | null}
 * @constructor
 */
export default function Content(): React.ReactElement | null {
  const block = useBlockContext();

  switch (block.type) {
    case BlockType.Test: return <components.Test />;
    case BlockType.AutoCheck: return <components.AutoCheck />;
    case BlockType.FreeAnswer: return <components.FreeAnswer />;
    case BlockType.Classification: return <components.Classification />;
    case BlockType.Accordance: return <components.Accordance />;
  }
}
